var exports = {
  "o1": "xa15a2ab7--63a350--legend",
  "Uc": "xa15a2ab7--63a350--heat-index",
  "AC": "xa15a2ab7--63a350--diagram",
};

module.exports = exports;
